"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverCommonProps = void 0;

var _Popover = _interopRequireDefault(require("../../Popover/Popover"));

var PopoverCommonProps = {
  appendTo: _Popover["default"].propTypes['appendTo'],
  flip: _Popover["default"].propTypes['flip'],
  fixed: _Popover["default"].propTypes['fixed'],
  placement: _Popover["default"].propTypes['placement'],
  timeout: _Popover["default"].propTypes['timeout'],
  zIndex: _Popover["default"].propTypes['zIndex'],
  onMouseEnter: _Popover["default"].propTypes['onMouseEnter'],
  onMouseLeave: _Popover["default"].propTypes['onMouseLeave'],
  moveArrowTo: _Popover["default"].propTypes['moveArrowTo'],
  moveBy: _Popover["default"].propTypes['moveBy'],
  hideDelay: _Popover["default"].propTypes['hideDelay'],
  showDelay: _Popover["default"].propTypes['showDelay'],
  width: _Popover["default"].propTypes['width'],
  maxWidth: _Popover["default"].propTypes['maxWidth'],
  minWidth: _Popover["default"].propTypes['minWidth'],
  dynamicWidth: _Popover["default"].propTypes['dynamicWidth']
};
exports.PopoverCommonProps = PopoverCommonProps;